import { useState } from "react";
import AppInputNew from "@/components/Core/AppInput/AppInputNew";
import Button from "@/components/Core/Button/Button";
import { useOrganisation, useUpdateOrganisation } from "@/networking/organisation.hooks";
import { SettingsLeaf } from "./SettingsLeafLayout";
import { IntegrationStatusRow } from "./integrationShared";

const ArbetsgivarintygPage = () => {
	const { data: organisation } = useOrganisation();
	const { mutate: updateOrganisation } = useUpdateOrganisation();

	const [apiKey, setApiKey] = useState(
		organisation?.arbetsgivarintyg?.available ? "***********" : ""
	);
	const [employerId, setEmployerId] = useState(organisation?.arbetsgivarintyg?.employerId || "");

	const available = !!organisation?.arbetsgivarintyg?.available;
	const enabled = !!organisation?.arbetsgivarintyg?.enabled;

	function save() {
		updateOrganisation({
			arbetsgivarintyg: {
				...(organisation?.arbetsgivarintyg || {}),
				// Don't overwrite the stored key when the masked placeholder is left untouched.
				apiKey: apiKey.startsWith("*****") ? organisation?.arbetsgivarintyg?.apiKey : apiKey,
				employerId,
				available: true,
				enabled: true,
			},
		});
	}

	return (
		<SettingsLeaf
			title="Arbetsgivarintyg.nu"
			description="Skapa en API-anslutning till arbetsgivarintyg.nu (Sveriges A-kassor) för att automatiskt skapa ett arbetsgivarintyg från Origo."
		>
			<div className="space-y-2">
				<IntegrationStatusRow
					activeTitle="Ja, tillgänglig för organisation"
					inactiveTitle="Ej tillgänglig, kontakta Origo för att aktivera"
					status={available}
				/>
				<IntegrationStatusRow
					activeTitle="Ja, koppling är aktiverad"
					inactiveTitle="Koppling ej aktiverad"
					status={enabled}
				/>
			</div>

			<AppInputNew
				label="API-nyckel"
				value={apiKey}
				onChangeText={setApiKey}
				disabled={!available}
			/>
			<AppInputNew
				label="Arbetsgivar-ID"
				value={employerId}
				onChangeText={setEmployerId}
				disabled={!available}
			/>
			<div>
				<Button width="200px" disabled={!available || !apiKey || !employerId} onClick={save}>
					{available && !enabled ? "Aktivera koppling" : "Spara ändringar"}
				</Button>
			</div>
		</SettingsLeaf>
	);
};

export default ArbetsgivarintygPage;
